var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AmeliproCard',{attrs:{"no-card-header":"","card-title":_vm.cardTitle},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.cardContent)+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }